import React from 'react';
import { useRecoilValue } from 'recoil';
import interactions from '../../../../state/interactions';
import ConnectingEdge from '../ConnectingEdge';
import CopyHoverPreviewEdge from '../CopyHoverPreviewEdge';

const EdgeDefinitions: React.FCC = React.memo(() => {
  const currentInteraction = useRecoilValue(interactions);

  if (currentInteraction?.type === 'connectAction') {
    return <ConnectingEdge />;
  }

  if (
    currentInteraction?.type === 'copyAction' &&
    currentInteraction.phase === 'choosingPathToConnect'
  ) {
    return <CopyHoverPreviewEdge />;
  }

  return null;
});

export default EdgeDefinitions;
